<template>
  <b-container>
    <b-row align-h="center">
      <b-col cols="6">
        <b-card>
          <b-form v-on:submit.prevent>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Account Type" label-for="account_type">
                  <v-select
                    id="account_type"
                    v-model="form.selectedAccountType"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsAccountType"
                    placeholder="Select 1 Account Type"
                    required
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedAccountType"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Name" label-for="name">
                  <b-form-input
                    id="name"
                    placeholder="Name"
                    v-model="form.name"
                    required
                  />
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Code" label-for="code">
                  <b-form-input
                    id="code"
                    placeholder="Code"
                    v-model="form.code"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Description" label-for="description">
                  <b-form-textarea
                    id="description"
                    placeholder="Description"
                    v-model="form.description"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="6">
                <b-form-group label="Currency" label-for="currency">
                  <v-select
                    id="currency"
                    v-model="form.selectedCurrency"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="text"
                    :options="form.optionsCurrency"
                    placeholder="Select 1 Currency"
                    required
                  >
                    <template #search="{ attributes, events }">
                      <input
                        class="vs__search"
                        :required="!form.selectedCurrency"
                        v-bind="attributes"
                        v-on="events"
                      />
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Balance" label-for="balance">
                  <cleave
                    id="balance"
                    placeholder="Balance"
                    v-model="form.balance"
                    class="form-control"
                    :raw="false"
                    :options="options.number"
                    required
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mt-2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="validation()"
                >
                  Update
                </b-button>
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="danger"
                  class="mr-1"
                  @click="deleteAccounts()"
                >
                  Delete
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BFormTextarea,
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import Cleave from "vue-cleave-component";

export default {
  components: {
    ToastificationContent,
    vSelect,
    Cleave,
    BFormTextarea,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        code: "",
        name: "",
        description: "",
        selectedAccountType: null,
        optionsAccountType: [],
        selectedCurrency: null,
        optionsCurrency: [],
        balance: null,
      },
      options: {
        number: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
        },
      },
      errors: "",
      errMessage: "",
    };
  },
  created() {
    this.getDetails();
    this.getAccountType();
    this.getCurrency();
  },
  methods: {
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("finance/account/" + id).then((response) => {
        this.form.code = response.data.data.code;
        this.form.name = response.data.data.name;
        this.form.description = response.data.data.description;
        this.form.selectedAccountType = {
          value: response.data.data.type,
          text: response.data.data.type_name,
        };
        this.form.selectedCurrency = {
          value: response.data.data.currency_id,
          text: response.data.data.currency_name,
        };
        this.form.balance = response.data.data.balance;
      });
    },
    getAccountType() {
      this.$http.get("finance/account/types").then((response) => {
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          this.form.optionsAccountType.push($data);
        }
      });
    },
    getCurrency() {
      this.$http.get("procurement/currencies/all").then((response) => {
        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          this.form.optionsCurrency.push($data);
        }
      });
    },
    validation() {
      if (this.form.code === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Code field is required",
            variant: "warning",
          },
        });
      } else if (this.form.name === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Name field is required",
            variant: "warning",
          },
        });
      } else if (this.form.description === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Description field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedAccountType === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Account Type field is required",
            variant: "warning",
          },
        });
      } else if (this.form.selectedCurrency === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Currency field is required",
            variant: "warning",
          },
        });
      } else if (this.form.balance === null) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Notification",
            icon: "BellIcon",
            text: "The Balance field is required",
            variant: "warning",
          },
        });
      } else {
        this.updateAccount();
      }
    },
    updateAccount() {
      const id = this.$route.params.id;
      var newBalance = this.form.balance;
      newBalance = newBalance.replace(/\,/g, "");
      this.$http
        .post("finance/account/" + id + "/update", {
          code: this.form.code,
          name: this.form.name,
          description: this.form.description,
          type: this.form.selectedAccountType.value,
          currency_id: this.form.selectedCurrency.value,
          balance: newBalance,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success update Account",
              variant: "success",
            },
          });
          location.href = "/finance/accounts";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    deleteAccounts() {
      const id = this.$route.params.id;
      this.$http
        .post("finance/account/" + id + "/delete")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Account has been Deleted",
              variant: "danger",
            },
          });
          location.href = "/finance/accounts";
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>